Vendd.Scripts.load(function () {
    'use strict';

    var $form = $('.x-giftcard'),
        $formMinimal = $('.x-giftcard-minimal'),
        form, formMinimal, formData,
        $submitButton, $clearButton, gcf;
    var model = null;

    if ($form.length < 1)
        return;

    var firstRun = true;

    form = $form.get(0);

    formData = {};

    //init validation options
    var validationOptions = {
        giftcardcode: {
            required: 'giftcardcode-required'
        }
    };

    form.loading = function loading (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        };
    };

    form.propButton = function propButton (enabled) {
        if (enabled) {
            $clearButton.prop('disabled', false).parent().removeClass('x-disabled');
        } else {
            $clearButton.prop('disabled', true).parent().addClass('x-disabled');
        };
    };

    form.show = function show () {
        $form.closest('.js-widget-container').show();
    };

    form.hide = function show () {
        $form.closest('.js-widget-container').hide();
    };

    form.bind = function bind(html) {
        $form.html(html);

        $submitButton = $('.js-submit', $form);
        $clearButton = $('.js-clear-all', $form);

        form.loading(false);

        if (firstRun) {
            if (!model.EnableGiftCardOneTimeCharge) {
                validationOptions.amount = {
                    required: 'amount-required'
                }
            }
            $form.validationEngine(validationOptions);
            gcf = $form.data('validationEngine');
            $form.removeClass('x-initializing');
            firstRun = false;
        } else {
            gcf.destroy();
            $form.validationEngine(validationOptions);
            gcf = $form.data('validationEngine');
        }
    };

    form.reset = function reset() {
        formData.giftcardcode = "";
        formData.amount = "";
        $('input[name="giftcardcode"]', $form).val("");
        $('input[name="amount"]', $form).val("");
        $('.js-giftcard-error', $form).hide();
        $('.js-giftcard-success', $form).hide();
    };

    form.submit = function submit () {
        form.loading(true);

        if (model.EnableGiftCardOneTimeCharge) formData.amount = null;

        Vendd.MessageBus.publishAsync(form, new Vendd.Cart.Messages.SetGiftCard(formData.giftcardcode, formData.amount));
    };

    form.giftCardApplySuccess = function (reponse) {
        form.reset();
        $.fancybox.close();
    }

    $form.on('keyup', 'input[name]', function (e) {

        if (e.keyCode == 13) {
            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();

        gcf.validate(fieldName);
    });

    $form.on('paste', 'input[name]', function (e) {
        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = e.originalEvent.clipboardData.getData('text');
    });

    $form.on('click', '.js-submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val1 = gcf.validate();

        if (val1) {
            form.submit();
        }

    });

    $form.on('click', '.js-clear-all', function (e) {
        e.preventDefault();
        e.stopPropagation();

        form.loading(true);

        form.reset();

        Vendd.MessageBus.publishAsync(form, new Vendd.Cart.Messages.ClearAllGiftCards());
    });

    $form.on('click', '.js-clear', function (e) {
        e.preventDefault();
        e.stopPropagation();

        Vendd.MessageBus.publishAsync(form, new Vendd.Cart.Messages.ClearGiftCard($(this).data('giftcardcode')));
    });

    if ($formMinimal.length > 0) {
        formMinimal = $formMinimal.get(0);

        formMinimal.bind = function bind(html) {
            $formMinimal.html(html);
        };

        $formMinimal.on('click', '.js-clear', function (e) {
            e.preventDefault();
            e.stopPropagation();

            Vendd.MessageBus.publishAsync(form, new Vendd.Cart.Messages.ClearGiftCard($(this).data('giftcardcode')));
        });
    }

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, form, function (envelope) {
        model = envelope.message.data.Cart;

        var html = Vendd.Handlebars.parse("giftCardWidget", model);
        form.bind(html);

        if ($formMinimal.length > 0) {
            var htmlMinimal = Vendd.Handlebars.parse("giftCardWidgetMinimal", model);
            formMinimal.bind(htmlMinimal);
        }

        if (model.IsEmpty) {
            form.hide();
        } else {
            form.show();
        };

        form.propButton(model.GiftCards.GiftCardItems.length > 0);

        form.reset();

        form.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GiftCardApplySuccess, form, form.giftCardApplySuccess);

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GiftCardApplyFailed, form, function (envelope) {
        var message = envelope.message.data.data.Message;
        if (envelope.message.data.success === true) {
            $('.js-giftcard-error', $form).hide();

            $('.js-giftcard-success', $form).text(message).show();
        } else {
            $('.js-giftcard-success', $form).hide();

            $('.js-giftcard-error', $form).text(message).show();
        }

        form.loading(false);
    });
});